// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple_earn_wrapper {
    padding: 40px 0 80px;
    background-color: transparent;
    min-height: 80vh;
}

/* button.aboutbtn_launchpad.earnbtn_simple {
    background-color: #f5f6f7;
    color: #000;
} */

.simple_earn_wrapper .container {
    max-width: 1240px;
}

/* Header and Banner section styling */
.launchpad_cnt_block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 18px;
}

.launchpad_left_cnt {
    flex: 1 1;
}

.launchpad_right_cnt {
    max-width: 440px;
}

body.light_theme .about-modal-intro-text {
    color: #353535 !important;
}

.launchpad_right_cnt img {
    width: 100%;
    height: auto;
    object-fit: contain;
}

.launchpad_cnt_block h1 {
    color: #ffffff;
    font-weight: 700;
}

body.light_theme .launchpad_cnt_block h1 {
    color: #070808;
}

.launchpad_cnt_block p {
    color: #84888C;
    font-size: 20px;
    font-weight: 500;
    margin: 18px 0px;
}

.launchpad_cnt_block ul {
    list-style: none;
    padding: 0;
    margin: 40px 0px 15px;
    display: flex;
    align-items: center;
    gap: 18px;
}

.launchpad_cnt_block ul li {
    display: flex;
    flex-direction: column;
    color: #ffffff;
    font-size: 29px;
    line-height: 26px;
    font-weight: 600;
}

body.light_theme .launchpad_cnt_block ul li {
    color: #070808;
}

.launchpad_cnt_block ul li span {
    color: #84888C;
    font-size: 12px;
    font-weight: 400;
}

.about_Launchpad_btn button {
    min-height: 56px;
    border-radius: 50px;
    border: none;
    background-color: #F5F6F7;
    transition: all 0.2s;
}

.about_Launchpad_btn button:hover {
    filter: brightness(0.9);
}

.about_Launchpad_btn button.aboutbtn_launchpad {
    background-color: #303236;
    color: #fff;
    font-size: 17px;
    font-weight: 500;
    padding: 10px 30px;
}

body.light_theme .about_Launchpad_btn button.aboutbtn_launchpad {
    background-color: #1e2329;
}

.about_Launchpad_btn button.notification_btn {
    width: 56px;
    background-color: #303236;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

body.light_theme .about_Launchpad_btn button.notification_btn {
    background-color: #F5F6F7;
    color: #000000;
}

.about_Launchpad_btn button i {
    font-size: 20px;
}

.recommed_btn .more_btn {
    border: none;
    padding: 0px;
    font-size: 16px;
    background: none;
    color: #fff;
}

body.light_theme .recommed_btn .more_btn {
    color: #292929;
}

/* Market Section General */
.market-section {
    padding: 40px 0;
    margin-top: 40px;
}

.market-title {
    font-size: 28px;
    font-weight: 700;
    color: #ffffff;
}

body.light_theme .market-title {
    color: #070808;
}

/* Controls */
.market-controls {
    display: flex;
    gap: 15px;
    align-items: center;
}

/* Custom Dropdown styling */
.market-dropdown-wrapper {
    position: relative;
    width: 180px;
    z-index: 100;
}

.market-dropdown-btn {
    width: 100%;
    background-color: #1e2329;
    color: #eaeaea;
    border: 1px solid #2d3139;
    border-radius: 8px;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: border-color 0.2s, background-color 0.2s;
}

.market-dropdown-btn:hover {
    border-color: #f0b90b;
}

body.light_theme .market-dropdown-btn {
    background-color: #f5f6f7;
    color: #1a1a1a;
    border-color: #eaeaea;
}


.dropdown-chev {
    transition: transform 0.2s;
}

.dropdown-chev.open {
    transform: rotate(180deg);
}

.market-dropdown-menu {
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    width: 100%;
    background-color: #1e2329;
    border: 1px solid #2d3139;
    border-radius: 8px;
    padding: 8px 0;
    margin: 0;
    list-style: none;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
    max-height: 250px;
    overflow-y: auto;
}

body.light_theme .market-dropdown-menu {
    background-color: #ffffff;
    border-color: #eaeaea;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.market-dropdown-item {
    padding: 10px 16px;
    font-size: 14px;
    color: #eaeaea;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
}

.market-dropdown-item:hover {
    background-color: #2b3139;
}

.market-dropdown-item.active {
    background-color: #2b3139;
    font-weight: 500;
}

body.light_theme .market-dropdown-item {
    color: #1a1a1a;
}

body.light_theme .market-dropdown-item:hover,
body.light_theme .market-dropdown-item.active {
    background-color: #f5f6f7;
}

/* Search input */
.market-search-wrapper {
    position: relative;
    width: 240px;
}

.market-search-wrapper .search-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #848e9c;
    font-size: 16px;
}

.market-search-input {
    width: 100%;
    background-color: #1e2329;
    color: #ffffff;
    border: 1px solid #2d3139;
    border-radius: 8px;
    padding: 10px 16px 10px 40px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
}

.market-search-input:focus {
    border-color: #f0b90b;
}

body.light_theme .market-search-input {
    background-color: #f5f6f7;
    color: #1a1a1a;
    border-color: #eaeaea;
}

/* Table Container & Table */
.market-table-container {
    width: 100%;
    overflow-x: auto;
    background-color: #12161a;
}

body.light_theme .market-table-container {
    background-color: #ffffff;
}

.market-table {
    width: 100%;
    border-collapse: collapse;
}

.market-table th {
    padding: 18px 15px;
    color: #848e9c;
    font-size: 14px;
    font-weight: 500;
}

body.light_theme .market-table th {
    color: #707a8a;
}

.market-table td {
    padding: 20px 15px;
    font-size: 15px;
    vertical-align: middle;
    color: #e2e2e2;
    font-weight: 500;

}

body.light_theme .market-table td {
    color: #121212;
}

/* Main Rows */
.market-main-row {
    transition: background-color 0.2s;
}

.market-main-row:hover {
    background-color: #1a1f26;
}

.market-main-row.expanded {
    background-color: #1a1f26;
    border-bottom: none;
}


body.light_theme .market-main-row:hover {
    background-color: #fafafa;
}

body.light_theme .market-main-row.expanded {
    background-color: #fafafa;
    border-bottom: none;
}

/* Coin Cell */
.market-coin-icon {
    width: 32px;
    height: 32px;
    object-fit: contain;
}

.market-coin-name {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
}

body.light_theme .market-coin-name {
    color: #1a1a1a;
}

.market-coin-fullname {
    font-size: 13px;
    color: #848e9c;
    display: block;
    margin-top: 2px;
}

/* Badges / Tags */
.market-tag {
    font-size: 10px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    text-transform: uppercase;
}

.tag-vip {
    background-color: rgba(240, 185, 11, 0.15);
    color: #f0b90b;
}

.tag-event {
    background-color: rgba(58, 142, 230, 0.15);
    color: #3a8ee6;
}

.tag-bonus {
    background-color: rgba(234, 179, 8, 0.15);
    color: #eab308;
}

/* APR text */
.green_text {
    color: #03a66d !important;
    font-weight: 600;
}

.market-term-summary {
    color: #eaeaea;
    font-weight: 500;
}

body.light_theme .market-term-summary {
    color: #101010
}

.market-toggle-btn {
    background: transparent;
    border: none;
    color: #848e9c;
    cursor: pointer;
    padding: 4px;
    font-size: 18px;
    transition: color 0.2s;
}

.market-toggle-btn:hover {
    color: #ffffff;
}

body.light_theme .market-toggle-btn:hover {
    color: #1a1a1a;
}

.market-chev-icon {
    display: inline-block;
    transition: transform 0.2s;
}

.market-chev-icon.open {
    transform: rotate(180deg);
}

/* Sub-row Styling (Expanded Campaigns) */
.market-sub-row {
    background-color: #161a1f;
}

body.light_theme .market-sub-row {
    background-color: #ffffff;
}

.market-sub-empty-cell {
    width: 25%;
}

/* APR Value with Tag and Trend */
.market-sub-apr-value.underlined {
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
}

body.light_theme .market-sub-apr-value.underlined {
    color: #1a1a1a;
}

/* Sub Badges */
.market-sub-badge {
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 4px;
    display: inline-block;
}

.badge-bonus {
    background-color: rgba(3, 166, 109, 0.12);
    color: #03a66d;
}

body.light_theme .badge-bonus {
    background-color: #e6fdf4;
    color: #03a66d;
}

.badge-v5-14 {
    background-color: rgba(240, 185, 11, 0.15);
    color: #d1aa67;
}

body.light_theme .badge-v5-14 {
    background-color: #fff9e6;
    color: #d1aa67;
}

.badge-new-users-exclusive {
    background-color: rgba(0, 184, 217, 0.15);
    color: #00b8d9;
}

body.light_theme .badge-new-users-exclusive {
    background-color: #e6fbfd;
    color: #008da6;
}

.badge-crazy-wednesday {
    background-color: rgba(0, 184, 217, 0.15);
    color: #00b8d9;
}

body.light_theme .badge-crazy-wednesday {
    background-color: #e6fbfd;
    color: #008da6;
}

.sub-row-chart-icon {
    font-size: 14px;
    color: #848e9c;
}

/* Term Pills */
.sub-term-pill {
    background-color: #1e2329;
    color: #848e9c;
    border: 1px solid transparent;
    border-radius: 8px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.sub-term-pill:hover {
    border-color: rgba(255, 255, 255, 0.3);
}

.sub-term-pill.active {
    border-color: #ffffff;
    background-color: transparent;
    color: #ffffff;
    font-weight: 600;
}

body.light_theme .sub-term-pill {
    background-color: #f5f6f7;
    color: #5e6673;
}

body.light_theme .sub-term-pill:hover {
    border-color: rgba(0, 0, 0, 0.2);
}

body.light_theme .sub-term-pill.active {
    border-color: #1e2329;
    background-color: #ffffff;
    color: #1e2329;
    font-weight: 600;
}

/* Subscribe button */
.market-subscribe-btn {
    background-color: #2b3139;
    color: #ffffff;
    border: none;
    border-radius: 20px;
    padding: 8px 24px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s, transform 0.1s;
}

.market-subscribe-btn:hover {
    background-color: #1e2329;
}

.market-subscribe-btn:active {
    transform: scale(0.97);
}

body.light_theme .market-subscribe-btn {
    background-color: #2b3139;
    color: #ffffff;
}

body.light_theme .market-subscribe-btn:hover {
    background-color: #000000;
}

/* Pagination Row */
.market-pagination {
    font-size: 13px;
    color: #848e9c;
}

.pagination-controls {
    display: flex;
    gap: 4px;
}

.pagination-btn {
    background-color: #1e2329;
    color: #eaeaea;
    border: 1px solid #2d3139;
    border-radius: 6px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
}

.pagination-btn:hover:not(.disabled):not(.active) {
    border-color: #f0b90b;
    color: #f0b90b;
}

.pagination-btn.active {
    background-color: #D1AA67;
    color: #000000;
    border-color: #D1AA67;
    font-weight: 600;
}

.pagination-btn.disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

body.light_theme .pagination-btn {
    background-color: #ffffff;
    color: #4b4f56;
    border-color: #eaeaea;
}

body.light_theme .pagination-btn:hover:not(.disabled):not(.active) {
    border-color: #D1AA67;
    color: #D1AA67;
}

body.light_theme .pagination-btn.active {
    background-color: #D1AA67;
    color: #ffffff;
    border-color: #D1AA67;
}

/* About Simple Earn Modal styling */
.about-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #000000ba;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    animation: fadeInModal 0.25s ease-out;
}

body.light_theme .about-modal-overlay {
    background-color: rgb(255 255 255 / 20%);
}

.about-modal-content {
    background-color: #1a1a1a69;
    color: #e1e1e1 !important;
    border: 1px solid rgba(255, 255, 255, 0.12);
    width: 90%;
    max-width: 600px;
    max-height: 85vh;
    border-radius: 20px;
    padding: 32px;
    position: relative;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-sizing: border-box;
}

body.light_theme .about-modal-content {
    background-color: #ffffff !important;
    color: #1e2329 !important;
}

.about-modal-close {
    position: absolute;
    top: 24px;
    right: 24px;
    background: transparent;
    border: none;
    font-size: 24px;
    color: #848e9c !important;
    cursor: pointer;
    transition: color 0.2s, transform 0.2s;
    padding: 4px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.about-modal-close:hover {
    color: #d3d3d3 !important;
}

body.light_theme .about-modal-title {
    color: #1e2329 !important;
}

.about-modal-title {
    font-size: 22px;
    font-weight: 700;
    color: #dddddd !important;
    margin: 0 0 24px 0;
    line-height: 1.2;
}

body.light_theme .about-modal-title {
    color: #1e2329 !important;
}

.about-modal-tabs {
    display: flex;
    gap: 24px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
}

.about-modal-tab {
    background: transparent;
    border: none;
    font-size: 16px;
    font-weight: 600;
    color: #848e9c !important;
    padding: 0 0 12px 0;
    cursor: pointer;
    position: relative;
    transition: color 0.2s;
}

.about-modal-tab:hover {
    color: #dfdfdf !important;
}

body.light_theme .about-modal-tab:hover {
    color: #1e2329 !important;
}

.about-modal-tab.active {
    color: #dfdfdf !important;
}

body.light_theme .about-modal-tab.active {

    color: #1e2329 !important;
}

.about-modal-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #eaeaea;
    border-radius: 2px;
}

body.light_theme .about-modal-tab.active::after {
    background-color: #1e2329;
}

.about-modal-body {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.about-modal-subtabs {
    display: flex;
    gap: 8px;
    margin-bottom: 20px;
}

.about-modal-subtab {
    background: transparent;
    border: none;
    font-size: 14px;
    font-weight: 600;
    color: #848e9c !important;
    padding: 8px 16px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s;
}

.about-modal-subtab:hover {
    color: #dddddd !important;
}

body.light_theme .about-modal-subtab:hover {
    color: #1e2329 !important;
}

.about-modal-subtab.active {
    background-color: #f5f6f7 !important;
    color: #1e2329 !important;
}

.about-modal-scrollable {
    overflow-y: auto;
    padding-right: 8px;
    flex: 1 1;
    max-height: 42vh;
}

.about-modal-scrollable::-webkit-scrollbar {
    width: 6px;
}

.about-modal-scrollable::-webkit-scrollbar-track {
    background: transparent;
}

.about-modal-scrollable::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 3px;
}

.about-modal-scrollable::-webkit-scrollbar-thumb:hover {
    background: #cbd5e1;
}

.about-modal-intro-text {
    font-size: 15px;
    font-weight: 600;
    color: #e0e0e0 !important;
    line-height: 1.5;
    margin-bottom: 24px;
}

body.light_theme .about-modal-section p {
    color: #1e2329 !important;
}

.about-modal-section {
    margin-bottom: 24px;
}

.about-modal-section h4 {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff !important;
    margin: 0 0 8px 0;
}

body.light_theme .about-modal-section h4 {
    color: #1e2329 !important;
}

.about-modal-section p {
    font-size: 14px;
    color: #d5d5d5 !important;
    line-height: 1.6;
    margin: 0 0 12px 0;
}

body.light_theme .about-modal-section p {
    color: #4b5563 !important;
}

.about-modal-section p:last-child {
    margin-bottom: 0;
}

.about-modal-learn-more {
    font-size: 14px;
    font-weight: 700;
    color: #1e2329 !important;
    text-decoration: underline;
    display: inline-block;
    margin-top: 8px;
    margin-bottom: 16px;
    transition: opacity 0.2s;
}

.about-modal-learn-more:hover {
    opacity: 0.8;
}

.about-modal-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
}

.about-modal-guide-btn {
    background-color: #1e2329 !important;
    color: #ffffff !important;
    border: none;
    border-radius: 24px;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s, transform 0.1s;
}

.about-modal-guide-btn:hover {
    background-color: #000000 !important;
}

.about-modal-guide-btn:active {
    transform: scale(0.97);
}

@keyframes fadeInModal {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUpModal {
    from {
        transform: translateY(20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@media screen and (max-width:1200px) {

    .launchpad_right_cnt {
        max-width: 330px;
    }


}


@media screen and (max-width:991px) {
    .launchpad_right_cnt {
        max-width: 280px;
    }

}

@media screen and (max-width:767px) {

    .launchpad_cnt_block {
        flex-direction: column-reverse;
        text-align: center;
        gap: 24px;
    }

    .launchpad_right_cnt {
        max-width: 230px;
        margin-top: 0px;
        order: -1;
    }

    .launchpad_cnt_block p {
        font-size: 16px;
        margin: 12px 0px;
    }

    .launchpad_cnt_block ul {
        margin: 20px 0px 15px;
        justify-content: center;
        flex-wrap: wrap;
        gap: 16px;
    }

    .launchpad_cnt_block ul li {
        font-size: 19px;
        line-height: 20px;
    }

    .about_Launchpad_btn {
        justify-content: center;
    }

    .about_Launchpad_btn button.aboutbtn_launchpad {
        font-size: 14px;
        padding: 6px 20px;
    }

    .about_Launchpad_btn button.notification_btn {
        width: 42px;
        padding: 0px;
    }

    .about_Launchpad_btn button {
        min-height: 42px;
    }

    .about-modal-overlay {
        align-items: end;
    }

    .about-modal-content {
        width: 100%;
        max-width: 100%;
        border-radius: 16px 16px 0px 0px;
        padding: 24px;
        box-shadow: 0 20px 40px rgb(0 0 0 / 73%);
    }

    .about-modal-title {
        font-size: 18px;
    }

    .about-modal-tab {
        font-size: 14px;
    }

    .about-modal-section p {
        font-size: 13px;
    }

    .about-modal-guide-btn {
        padding: 8px 24px;
        font-size: 13px;
    }



}

/* Subscription Modal styling */
.sub-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #000000ba;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    animation: fadeInModal 0.25s ease-out;
}

body.light_theme .sub-modal-overlay {
    background-color: rgb(255 255 255 / 20%);
}

.sub-modal-content {
    background-color: #1a1a1a69;
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #e0e0e0 !important;
    width: 95%;
    max-width: 820px;
    max-height: 90vh;
    border-radius: 20px;
    padding: 32px;
    position: relative;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-sizing: border-box;
}

body.light_theme .sub-modal-content {
    background-color: #ffffff !important;
    color: #1e2329 !important;
}

.sub-modal-close {
    position: absolute;
    top: 24px;
    right: 24px;
    background: transparent;
    border: none;
    font-size: 24px;
    color: #848e9c !important;
    cursor: pointer;
    transition: color 0.2s, transform 0.2s;
    padding: 4px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.sub-modal-close:hover {
    color: #1e2329 !important;
}

.sub-modal-layout {
    display: flex;
    gap: 40px;
    margin-top: 10px;
}

/* Left Column Styling */
.sub-modal-left {
    flex: 1.1 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.sub-modal-coin-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
}

.sub-modal-coin-icon {
    width: 32px;
    height: 32px;
    object-fit: contain;
}

.sub-modal-coin-name {
    font-size: 22px;
    font-weight: 700;
    color: #e6e6e6;
}

body.light_theme .sub-modal-coin-name {

    color: #1e2329;
}

/* Term selector cards */
.sub-modal-term-list {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
    overflow-x: auto;
    padding-bottom: 6px;
}

.sub-modal-term-list::-webkit-scrollbar {
    height: 4px;
}

.sub-modal-term-list::-webkit-scrollbar-track {
    background: transparent;
}

.sub-modal-term-list::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 2px;
}

.sub-modal-term-card {
    border: 1px solid #eaeaea1f;
    border-radius: 12px;
    padding: 14px 16px;
    min-width: 105px;
    cursor: pointer;
    transition: all 0.2s;
    background-color: #ffffff00;
    box-sizing: border-box;
}

body.light_theme .sub-modal-term-card {
    background-color: #ffffff;
    border: 1px solid #eaeaea;
}

.sub-modal-term-card:hover {
    border-color: #1e2329;
    background-color: #ffffff00;
}

body.light_theme .sub-modal-term-card:hover {
    border-color: #cbd5e1;
    background-color: #fafafa;
}

.sub-modal-term-card.active {
    border-color: #1e2329 !important;
    border-width: 1.5px;
}

.sub-modal-term-apr {
    font-size: 16px;
    font-weight: 700;
    color: #f1f1f1;
}

body.light_theme .sub-modal-term-apr {
    color: #1e2329;
}

.sub-modal-term-label {
    font-size: 12px;
    color: #848e9c !important;
    margin-top: 4px;
    font-weight: 500;
}

/* Amount field styling */
.sub-modal-amount-section {
    margin-bottom: 24px;
}

.sub-modal-amount-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.sub-modal-label {
    font-size: 14px;
    font-weight: 600;
    color: #d2d2d2 !important;
}

body.light_theme .sub-modal-label {
    color: #1e2329 !important;
}

.sub-modal-auto-earn {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #d2d2d2 !important;
    font-weight: 500;
    cursor: pointer;
}

body.light_theme .sub-modal-auto-earn {
    color: #1e2329 !important;
}

.sub-modal-auto-earn input {
    cursor: pointer;
}

.sub-modal-input-wrapper {
    display: flex;
    align-items: center;
    background-color: #f5f6f705;
    border-radius: 12px;
    padding: 14px 16px;
    border: 1.5px solid transparent;
    transition: border-color 0.2s;
}

body.light_theme .sub-modal-input-wrapper {
    background-color: #f5f6f7;
}

.sub-modal-input-wrapper:focus-within {
    border-color: #1e2329;
    background-color: #ffffff;
}

.sub-modal-amount-input {
    border: none;
    background: transparent;
    font-size: 16px;
    font-weight: 600;
    color: #1e2329 !important;
    width: 60%;
    outline: none;
    padding: 0;
}

.sub-modal-input-right {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: auto;
}

.sub-modal-token-name {
    font-weight: 700;
    font-size: 14px;
    color: #dddddd;
}

body.light_theme .sub-modal-token-name {
    color: #1e2329;
}

.sub-modal-input-divider {
    width: 1px;
    height: 16px;
    background-color: #eaeaea;
}

.sub-modal-max-btn {
    color: #b8860b !important;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: opacity 0.2s;
}

.sub-modal-max-btn:hover {
    opacity: 0.8;
}

.sub-modal-amount-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    margin-top: 8px;
}

.sub-modal-available-link {
    color: #848e9c !important;
    border-bottom: 1px dotted #848e9c;
    cursor: pointer;
    transition: color 0.2s;
}

/* .sub-modal-available-link:hover {
    color: #1e2329 !important;
} */

.sub-modal-available-val {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #d6d6d6;
    font-weight: 600;
}

body.light_theme .sub-modal-available-val {
    color: #1e2329;
}

.sub-modal-add-icon {
    color: #e5e5e5;
    cursor: pointer;
    font-size: 14px;
    transition: transform 0.2s;
}

body.light_theme .sub-modal-add-icon {
    color: #3c3c3c;
}

.sub-modal-add-icon:hover {
    transform: scale(1.15);
}

/* APR Box details */
.sub-modal-apr-title {
    font-size: 14px;
    font-weight: 600;
    color: #dadada;
    margin: 0 0 12px 0;
}

body.light_theme .sub-modal-apr-title {
    color: #1e2329;
}

.sub-modal-apr-box {
    border: 1px solid #f5f6f717;
    border-radius: 12px;
    padding: 16px;
    background-color: #ffffff08;

}

body.light_theme .sub-modal-apr-box {
    border: 1px solid #f5f6f7;
    background-color: #ffffff;
}

.sub-modal-apr-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    margin-bottom: 12px;
}

.sub-modal-apr-row:last-child {
    margin-bottom: 0;
}

.sub-modal-apr-row-label {
    color: #848e9c !important;
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
}

.sub-modal-apr-row-val {
    font-weight: 700;
    color: #d8d8d8;
}

body.light_theme .sub-modal-apr-row-val {
    color: #1e2329;
}

.sub-modal-apr-bonus-label {
    font-size: 11px;
    font-weight: 700;
    color: #848e9c !important;
    margin-top: 14px;
    margin-bottom: 6px;
    text-transform: uppercase;
}

.green-tick {
    color: #03a66d !important;
    font-size: 15px;
}

/* Right Column Styling */
.sub-modal-right {
    flex: 0.9 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.sub-modal-return-title {
    font-size: 14px;
    font-weight: 600;
    color: #dcdcdc !important;
    margin: 0 0 12px 0;
    display: inline-block;
    border-bottom: 1px dotted #848e9c;
    cursor: help;
}

body.light_theme .sub-modal-return-title {
    color: #1e2329 !important;
}

.sub-modal-return-box {
    border: 1px solid #f5f6f717;
    border-radius: 12px;
    padding: 18px 16px;
    background-color: #ffffff08;
    margin-bottom: 24px;
}

body.light_theme .sub-modal-return-box {
    border: 1px solid #f5f6f7;
    background-color: #ffffff;
}

.sub-modal-return-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 12px;
}

.sub-modal-return-row:last-child {
    margin-bottom: 0;
}

.sub-modal-mini-icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.sub-modal-return-amount {
    font-size: 15px;
}

.sub-modal-bonus-badge {
    background-color: #e6fbfd !important;
    color: #008da6 !important;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 700;
    margin-left: auto;
}

/* Timeline & Rules tabs */
.sub-modal-rules-tabs {
    display: flex;
    gap: 20px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 16px;
}

.sub-modal-rules-tab {
    background: transparent;
    border: none;
    font-size: 14px;
    font-weight: 600;
    color: #848e9c !important;
    padding-bottom: 10px;
    cursor: pointer;
    position: relative;
    transition: color 0.2s;
}

.sub-modal-rules-tab:hover {
    color: #ededed !important;
}

body.light_theme .sub-modal-rules-tab:hover {
    color: #1e2329 !important;
}

.sub-modal-rules-tab.active {
    color: #ededed !important;
}

body.light_theme .sub-modal-rules-tab.active {
    color: #1e2329 !important;
}

.sub-modal-rules-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #1e2329;
    border-radius: 2px;
}

.sub-modal-rules-content {
    flex: 1 1;
    min-height: 160px;
}

.sub-modal-timeline {
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: relative;
    padding-left: 20px;
    padding-top: 6px;
}

.sub-modal-timeline-line {
    position: absolute;
    left: 5px;
    top: 12px;
    bottom: 12px;
    width: 2px;
    background-color: #eaeaea;
}

.sub-modal-timeline-step {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    position: relative;
}

.sub-modal-timeline-bullet {
    position: absolute;
    left: -20px;
    top: 3px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #eaeaea;
    border: 2px solid #ffffff;
    box-sizing: border-box;
}

.sub-modal-timeline-bullet.active {
    background-color: #1e2329 !important;
}

.sub-modal-step-label {
    font-weight: 600;
    color: #e1e1e1 !important;
    border-bottom: 1px dotted #eaeaea;
    cursor: help;
}

body.light_theme .sub-modal-step-label {
    color: #1e2329 !important;
}

.sub-modal-step-val {
    color: #848e9c !important;
    font-weight: 500;
}

.sub-modal-product-rules {
    font-size: 13px;
    color: #eaeaea;
    line-height: 1.6;
}

body.light_theme .sub-modal-product-rules {
    color: #4b5563;
}

.sub-modal-product-rules p {
    margin: 0 0 10px 0;
}

.sub-modal-product-rules p:last-child {
    margin-bottom: 0;
}

/* Footer Submit btn */
.sub-modal-footer {
    margin-top: auto;
    padding-top: 16px;
}

.sub-modal-submit-btn {
    width: 100%;
    border: none;
    border-radius: 24px;
    padding: 12px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
}

.sub-modal-submit-btn.active {
    background-color: #1e2329 !important;
    color: #ffffff !important;
}

.sub-modal-submit-btn.active:hover {
    background-color: #000000 !important;
}

.sub-modal-submit-btn.disabled {
    background-color: #f5f6f7 !important;
    color: #cbd5e1 !important;
    cursor: not-allowed;
}

/* Responsive constraints */
@media screen and (max-width: 767px) {
    .sub-modal-content {
        width: 100%;
        max-width: 100%;
        border-radius: 16px 16px 0 0;
        padding: 24px;
        max-height: 90vh;
        overflow-y: auto;
    }

    .recommed_btn .more_btn {
        font-size: 14px;
    }

    .sub-modal-layout {
        flex-direction: column;
        gap: 24px;
        margin: 0px;
    }

    .sub-modal-rules-content {
        min-height: auto;
    }
}

/* Enable Auto-Earn Modal styling */
.auto-earn-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(30, 35, 41, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000000000;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    animation: fadeInModal 0.2s ease-out;
}

body.light_theme .auto-earn-modal-overlay {
    background-color: rgb(255 255 255 / 20%);
}

.auto-earn-modal-content {
    background-color: #1e232999 !important;
    color: #efefef !important;
    width: 90%;
    max-width: 500px;
    border-radius: 20px;
    border: 1px solid #2b3139;
    padding: 32px;
    position: relative;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    animation: slideUpModal 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    box-sizing: border-box;
}

body.light_theme .auto-earn-modal-content {
    background-color: #ffffff !important;
    color: #1e2329 !important;
    border: none;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}

.auto-earn-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.auto-earn-modal-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    font-size: 18px;
    cursor: pointer;
    color: #eaecef !important;
    transition: opacity 0.2s;
}

body.light_theme .auto-earn-modal-header-left {
    color: #1e2329 !important;
}

.auto-earn-modal-header-left:hover {
    opacity: 0.8;
}

.auto-earn-modal-close {
    background: transparent;
    border: none;
    font-size: 26px;
    color: #848e9c !important;
    cursor: pointer;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.auto-earn-modal-close:hover {
    color: #eaecef !important;
}

body.light_theme .auto-earn-modal-close:hover {
    color: #1e2329 !important;
}

.auto-earn-illustration {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
}

.auto-earn-description {
    font-size: 14px;
    color: #848e9c !important;
    line-height: 1.6;
    margin: 0 0 20px 0;
}

body.light_theme .auto-earn-description {
    color: #4b5563 !important;
}

.auto-earn-warning-box {
    display: flex;
    gap: 12px;
    background-color: rgba(245, 158, 11, 0.1) !important;
    border: 1px solid rgba(245, 158, 11, 0.2);
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 24px;
}

body.light_theme .auto-earn-warning-box {
    background-color: #fffbeb !important;
    border: 1px solid #fef3c7;
}

.auto-earn-warning-icon {
    color: #f59e0b !important;
    font-size: 20px;
    line-height: 1;
}

.auto-earn-warning-text {
    font-size: 12px;
    color: #fcd34d !important;
    line-height: 1.5;
    margin: 0;
}

body.light_theme .auto-earn-warning-text {
    color: #78350f !important;
}

.auto-earn-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.auto-earn-cancel-btn {
    border: 1px solid #2b3139;
    background-color: transparent;
    border-radius: 24px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    color: #eaecef !important;
    transition: all 0.2s;
}

body.light_theme .auto-earn-cancel-btn {
    border: 1px solid #eaeaea;
    color: #1e2329 !important;
}

.auto-earn-cancel-btn:hover {
    background-color: #2b3139 !important;
}

body.light_theme .auto-earn-cancel-btn:hover {
    background-color: #f5f6f7 !important;
}

.auto-earn-confirm-btn {
    background-color: #eaecef !important;
    color: #181a20 !important;
    border: none;
    border-radius: 24px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
}

body.light_theme .auto-earn-confirm-btn {
    background-color: #1e2329 !important;
    color: #ffffff !important;
}

.auto-earn-confirm-btn:hover {
    background-color: #ffffff !important;
}

body.light_theme .auto-earn-confirm-btn:hover {
    background-color: #000000 !important;
}

.auto-earn-illustration {
    filter: invert(1) hue-rotate(180deg);
}

body.light_theme .auto-earn-illustration {
    filter: none;
}

@media screen and (max-width: 767px) {
    .auto-earn-modal-overlay {
        align-items: end;
    }

    .auto-earn-modal-content {
        width: 100%;
        max-width: 100%;
        border-radius: 16px 16px 0 0;
        padding: 24px;
        height: 80vh;
        overflow: scroll;
    }
}

/* Invite Friends Modal styling */
.invite-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #000000ba;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    animation: fadeInModal 0.25s ease-out;
}

body.light_theme .invite-modal-overlay {
    background-color: rgb(255 255 255 / 20%) !important;
}

.invite-modal-content {
    background-color: #1a1a1a69;
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #e3e3e3 !important;
    width: 90%;
    max-width: 680px;
    border-radius: 20px;
    padding: 32px;
    position: relative;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-sizing: border-box;
}

body.light_theme .invite-modal-content {
    background-color: #ffffff !important;
    color: #1e2329 !important;
}

.invite-modal-close {
    position: absolute;
    top: 24px;
    right: 24px;
    background: transparent;
    border: none;
    font-size: 26px;
    color: #848e9c !important;
    cursor: pointer;
    transition: color 0.2s;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.invite-modal-close:hover {
    color: #1e2329 !important;
}

.invite-modal-title {
    font-size: 22px;
    font-weight: 700;
    color: #e1e1e1 !important;
    margin: 0 0 24px 0;
    line-height: 1.2;
}

body.light_theme .invite-modal-title {
    color: #1e2329 !important;
}

.invite-modal-layout {
    display: flex;
    gap: 32px;
}

/* Left side Card template */
.invite-modal-left {
    width: 240px;
    flex-shrink: 0;
    border-radius: 16px;
    border: 1px solid #eaeaea;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.invite-card-media {
    background-color: #12161c;
    padding: 28px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #ffffff;
    flex: 1 1;
}

.invite-card-logo-container {
    margin-bottom: 12px;
}

.invite-card-brand-name {
    font-weight: 700;
    font-size: 18px;
    letter-spacing: 1px;
    color: #ffffff !important;
    line-height: 1.2;
}

.invite-card-tagline {
    font-size: 11px;
    color: #848e9c !important;
    margin-top: 4px;
}

.invite-card-apr-badge {
    font-size: 11px;
    font-weight: 700;
    color: #ffffff !important;
    background: linear-gradient(90deg, #f39c12, #f1c40f);
    border-radius: 12px;
    padding: 4px 10px;
    margin-top: 14px;
}

.invite-card-bottom {
    padding: 16px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    border-top: 1px solid #eaeaea;
}

.invite-card-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.invite-card-code-label {
    font-weight: 700;
    font-size: 12px;
    color: #1e2329 !important;
}

.invite-card-reward-label {
    font-size: 9px;
    color: #848e9c !important;
    line-height: 1.2;
}

.invite-card-qr {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.invite-card-qr svg {
    width: 100% !important;
    height: 100% !important;
    display: block;
}

.highlight-blue {
    color: #0066FF !important;
    font-weight: 700;
}

/* Right side Referral setup */
.invite-modal-right {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.invite-field-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.invite-field-label {
    font-size: 12px;
    font-weight: 700;
    color: #848e9c !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.invite-code-input-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f5f6f708;
    border-radius: 10px;
    padding: 10px 16px;
}

body.light_theme .invite-code-input-container {
    background-color: #f5f6f7;
}

.invite-code-text {
    font-weight: 500;
    font-size: 15px;
    color: #d5d5d5 !important;
}

body.light_theme .invite-code-text {
    color: #1e2329 !important;
}

.invite-code-copy-btn {
    background: #f5f6f705;
    border: none;
    color: #c6c6c6 !important;
    font-size: 16px;
    cursor: pointer;
    padding: 4px;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

body.light_theme .invite-custom-textbox {
    color: #848e9c !important;
    background-color: #f5f6f7;
}

.invite-code-copy-btn:hover {
    color: #1e2329 !important;
}

.invite-custom-textbox {
    background-color: #f5f6f70a;
    border-radius: 12px;
    padding: 14px 16px;
    font-size: 13px;
    color: #dedede !important;
    line-height: 1.6;
    cursor: pointer;
    transition: background-color 0.2s, border-color 0.2s;
    border: 1.5px solid transparent;
}

/* .invite-custom-textbox:hover {
    background-color: #eaeaea;
    border-color: #cbd5e1;
} */

.invite-share-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 14px 10px;
    margin-top: 8px;
}

.invite-share-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    cursor: pointer;
}

.invite-share-circle {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff !important;
    font-size: 18px;
    transition: transform 0.2s, filter 0.2s;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.invite-share-item:hover .invite-share-circle {
    transform: translateY(-2px);
    filter: brightness(0.95);
}

.invite-share-circle.grey-circle {
    background-color: #f1f2f4;
    color: #1e2329 !important;
}

.invite-share-circle.telegram-circle {
    background-color: #229ED9;
}

.invite-share-circle.whatsapp-circle {
    background-color: #25D366;
}

.invite-share-circle.x-circle {
    background-color: #000000;
}

.invite-share-circle.facebook-circle {
    background-color: #1877F2;
}

.invite-share-circle.linkedin-circle {
    background-color: #0A66C2;
}

.invite-share-circle.line-circle {
    background-color: #06C755;
}

.invite-share-circle.email-circle {
    background-color: #0066FF;
}

.invite-share-name {
    font-size: 11px;
    color: #4b5563 !important;
    font-weight: 600;
    margin-top: 6px;
}


@media screen and (max-width: 991px) {

    .about_Launchpad_btn button.aboutbtn_launchpad {
        font-size: 14px;
        padding: 8px 28px;
        min-height: 40px;
    }

    .launchpad_cnt_block p {
        font-size: 16px;
    }

    .about_Launchpad_btn button.notification_btn {
        width: 48px;
        min-height: 48px;
        min-width: 48px;
        height: 48px;
    }

}


@media screen and (max-width: 767px) {
    .invite-modal-content {
        width: 100%;
        max-width: 100%;
        border-radius: 16px 16px 0 0;
        padding: 24px;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 20px 40px rgb(0 0 0 / 59%);
    }

    .invite-modal-layout {
        flex-direction: column;
        align-items: center;
        gap: 24px;
    }

    .invite-modal-overlay {
        align-items: end;
    }

    section.market-section.mt-5.mb-5 {
        margin: 0px !important;
        padding-top: 10px;
    }

    .market-title {
        font-size: 24px;
    }

    /* Table to cardbox styling on mobile */
    .market-table-container {
        background: transparent !important;
        overflow-x: visible !important;
    }

    .launchpad_cnt_block p {
        font-size: 14px;
    }

    .market-table {
        display: block !important;
        width: 100% !important;
    }

    .market-table thead {
        display: none !important;
        /* Hide column headers on mobile */
    }

    .market-controls.d-flex.gap-3.align-items-center.flex-wrap {
        flex-wrap: nowrap !important;
    }

    .market-search-wrapper {
        width: auto;
    }

    .market-table tbody {
        display: flex !important;
        flex-direction: column !important;
        gap: 14px;
        width: 100% !important;
        padding: 4px 0;
    }

    .market-main-row {
        display: flex !important;
        flex-wrap: wrap !important;
        align-items: center !important;
        background-color: #12161a !important;
        border-radius: 12px !important;
        padding: 16px 20px !important;
        margin-bottom: 0px !important;
        border: 1px solid rgba(255, 255, 255, 0.03) !important;
        position: relative !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        transition: border-radius 0.2s ease !important;
    }

    body.light_theme .market-main-row {
        background-color: #f8f9fa !important;
        border: 1px solid #eaecef !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04) !important;
    }

    /* Adjust the border radius when main row is expanded so sub-rows merge cleanly */
    .market-main-row.expanded {
        border-bottom-left-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
        background-color: #1a1f26 !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
    }

    body.light_theme .market-main-row.expanded {
        background-color: #f1f2f4 !important;
        border-bottom: 1px solid #eaecef !important;
    }

    .market-main-row td {
        display: block !important;
        padding: 0px !important;
        border: none !important;
        background: transparent !important;
    }

    /* Column 1: Coin details */
    .market-main-row td:nth-child(1) {
        flex: 1 1 50% !important;
        min-width: 0 !important;
        display: flex !important;
        align-items: center !important;
    }

    /* Column 2: Est. APR */
    .market-main-row td:nth-child(2) {
        flex: 1 1 35% !important;
        text-align: right !important;
        font-weight: 600 !important;
        font-size: 16px !important;
        padding-right: 30px !important;
        /* Avoid overlap with absolute chev button */
    }

    /* Prepend label to APR */
    .market-main-row td:nth-child(2)::before {
        content: "Est. APR" !important;
        font-size: 11px !important;
        color: #848e9c !important;
        font-weight: 400 !important;
        display: block !important;
        margin-bottom: 2px !important;
    }

    .market-main-row td:nth-child(2) .market-apr-value {
        color: #03a66d !important;
    }

    /* Column 3: Term */
    .market-main-row td:nth-child(3) {
        flex: 1 1 100% !important;
        /* Full width row below */
        margin-top: 12px !important;
        padding-top: 12px !important;
        border-top: 1px dashed rgba(255, 255, 255, 0.06) !important;
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
    }

    body.light_theme .market-main-row td:nth-child(3) {
        border-top: 1px dashed #eaecef !important;
    }

    .market-main-row td:nth-child(3)::before {
        content: "Term" !important;
        font-size: 13px !important;
        color: #848e9c !important;
        font-weight: 500 !important;
    }

    .market-term-summary {
        font-size: 13px !important;
        color: #ffffff !important;
    }

    body.light_theme .market-term-summary {
        color: #1e2329 !important;
    }

    /* Column 4: Toggle Chevron button */
    .market-main-row td:nth-child(4) {
        position: absolute !important;
        right: 16px !important;
        top: 24px !important;
        display: block !important;
    }

    .market-toggle-btn {
        padding: 4px !important;
    }

    /* Expanded Sub Rows (Campaigns) */
    .market-sub-row {
        display: flex !important;
        flex-direction: column !important;
        background-color: #161a20 !important;
        border-left: 1px solid rgba(255, 255, 255, 0.04) !important;
        border-right: 1px solid rgba(255, 255, 255, 0.04) !important;
        padding: 16px 20px !important;
        gap: 12px !important;
        margin-top: 0px !important;
    }

    body.light_theme .market-sub-row {
        background-color: #ffffff !important;
    }

    /* Last sub-row has rounded bottom corners */
    .market-sub-row:last-of-type {
        border-bottom-left-radius: 12px !important;
        border-bottom-right-radius: 12px !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;
        margin-bottom: 12px !important;
    }

    body.light_theme .market-sub-row:last-of-type {
        border-bottom: 1px solid #eaecef !important;
    }

    .market-sub-row td {
        display: block !important;
        padding: 0px !important;
        border: none !important;
        background: transparent !important;
        width: 100% !important;
    }

    .sub-modal-coin-name {
        font-size: 20px;
    }

    .sub-modal-amount-input {
        font-size: 13px;
    }

    .sub-modal-term-card {
        padding: 10px 12px;
        min-width: auto;
    }

    .sub-modal-overlay {
        align-items: end;
    }


    .simple_earn_wrapper {
        padding: 40px 0 20px;
    }

    /* Hide the empty cell td:nth-child(1) in sub-row */
    .market-sub-row td.market-sub-empty-cell {
        display: none !important;
    }

    /* Sub-row APR and badges */
    .market-sub-row td:nth-child(2) {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
    }

    .market-sub-row td:nth-child(2)::before {
        content: "Campaign APR" !important;
        font-size: 13px !important;
        color: #848e9c !important;
        font-weight: 500 !important;
    }

    .market-sub-row td:nth-child(2)>div {
        display: flex !important;
        align-items: center !important;
        gap: 6px !important;
    }

    /* Sub-row terms / days pills */
    .market-sub-row td:nth-child(3) {
        display: flex !important;
        flex-direction: column !important;
        gap: 6px !important;
        align-items: flex-start !important;
    }

    .market-sub-row td:nth-child(3)::before {
        content: "Select Term" !important;
        font-size: 13px !important;
        color: #848e9c !important;
        font-weight: 500 !important;
        align-self: flex-start !important;
    }

    .sub-term-pill {
        padding: 6px 14px !important;
        font-size: 12px !important;
    }

    /* Sub-row Action (Subscribe Button) */
    .market-sub-row td:nth-child(4) {
        margin-top: 6px !important;
        text-align: left !important;
    }

    .market-subscribe-btn {
        width: 100% !important;
        text-align: center !important;
        padding: 8px !important;
        border-radius: 8px !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        display: block !important;
    }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/SimpleEarn/simple_earn.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;;;GAGG;;AAEH;IACI,iBAAiB;AACrB;;AAEA,sCAAsC;AACtC;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oDAAoD;AACxD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yCAAyC;AACzC;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA,iCAAiC;AACjC;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA,oCAAoC;AACpC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kCAAkC;IAClC,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,2CAA2C;IAC3C,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,sCAAsC;IACtC,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;;IAEI;QACI,gBAAgB;IACpB;;;AAGJ;;;AAGA;IACI;QACI,gBAAgB;IACpB;;AAEJ;;AAEA;;IAEI;QACI,8BAA8B;QAC9B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,gCAAgC;QAChC,aAAa;QACb,wCAAwC;IAC5C;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;;;AAIJ;;AAEA,+BAA+B;AAC/B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kCAAkC;IAClC,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;IAC3C,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,sCAAsC;IACtC,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,WAAS;IACT,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,2BAA2B;;AAE/B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,WAAS;IACT,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,SAAS;IACT,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,YAAY;IACZ,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI;QACI,WAAW;QACX,eAAe;QACf,4BAA4B;QAC5B,aAAa;QACb,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,mCAAmC;AACnC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,wCAAwC;IACxC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kCAA0B;YAA1B,0BAA0B;IAC1B,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,sCAAsC;IACtC,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,2DAA2D;IAC3D,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,oDAAoD;IACpD,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,4BAA4B;QAC5B,aAAa;QACb,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA,iCAAiC;AACjC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kCAAkC;IAClC,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;IAC3C,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA,4BAA4B;AAC5B;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,SAAO;AACX;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oDAAoD;IACpD,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,oDAAoD;IACpD,+BAA+B;AACnC;;AAEA;;;GAGG;;AAEH;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,uCAAuC;IACvC,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;;IAEI;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,eAAe;QACf,YAAY;IAChB;;AAEJ;;;AAGA;IACI;QACI,WAAW;QACX,eAAe;QACf,4BAA4B;QAC5B,aAAa;QACb,gBAAgB;QAChB,gBAAgB;QAChB,wCAAwC;IAC5C;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA,uCAAuC;IACvC;QACI,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;QACxB,kCAAkC;IACtC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,wBAAwB;QACxB,iCAAiC;QACjC,SAAS;QACT,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,wBAAwB;QACxB,0BAA0B;QAC1B,8BAA8B;QAC9B,oCAAoC;QACpC,8BAA8B;QAC9B,6BAA6B;QAC7B,6BAA6B;QAC7B,sDAAsD;QACtD,6BAA6B;QAC7B,qDAAqD;QACrD,8CAA8C;IAClD;;IAEA;QACI,oCAAoC;QACpC,oCAAoC;QACpC,qDAAqD;IACzD;;IAEA,iFAAiF;IACjF;QACI,yCAAyC;QACzC,0CAA0C;QAC1C,oCAAoC;QACpC,6DAA6D;IACjE;;IAEA;QACI,oCAAoC;QACpC,2CAA2C;IAC/C;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;QACvB,uBAAuB;QACvB,kCAAkC;IACtC;;IAEA,2BAA2B;IAC3B;QACI,wBAAwB;QACxB,uBAAuB;QACvB,wBAAwB;QACxB,8BAA8B;IAClC;;IAEA,uBAAuB;IACvB;QACI,wBAAwB;QACxB,4BAA4B;QAC5B,2BAA2B;QAC3B,0BAA0B;QAC1B,8BAA8B;QAC9B,4CAA4C;IAChD;;IAEA,yBAAyB;IACzB;QACI,8BAA8B;QAC9B,0BAA0B;QAC1B,yBAAyB;QACzB,2BAA2B;QAC3B,yBAAyB;QACzB,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA,mBAAmB;IACnB;QACI,yBAAyB;QACzB,yBAAyB;QACzB,2BAA2B;QAC3B,4BAA4B;QAC5B,2DAA2D;QAC3D,wBAAwB;QACxB,yCAAyC;QACzC,8BAA8B;IAClC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,0BAA0B;QAC1B,0BAA0B;QAC1B,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA,oCAAoC;IACpC;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,oBAAoB;QACpB,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA,kCAAkC;IAClC;QACI,wBAAwB;QACxB,iCAAiC;QACjC,oCAAoC;QACpC,2DAA2D;QAC3D,4DAA4D;QAC5D,6BAA6B;QAC7B,oBAAoB;QACpB,0BAA0B;IAC9B;;IAEA;QACI,oCAAoC;IACxC;;IAEA,4CAA4C;IAC5C;QACI,0CAA0C;QAC1C,2CAA2C;QAC3C,6DAA6D;QAC7D,8BAA8B;IAClC;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;QACvB,uBAAuB;QACvB,kCAAkC;QAClC,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,oBAAoB;IACxB;;IAEA,mDAAmD;IACnD;QACI,wBAAwB;IAC5B;;IAEA,2BAA2B;IAC3B;QACI,wBAAwB;QACxB,8BAA8B;QAC9B,yCAAyC;IAC7C;;IAEA;QACI,kCAAkC;QAClC,0BAA0B;QAC1B,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;QACxB,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA,+BAA+B;IAC/B;QACI,wBAAwB;QACxB,iCAAiC;QACjC,mBAAmB;QACnB,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;QACjC,0BAA0B;QAC1B,yBAAyB;QACzB,2BAA2B;QAC3B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,0BAA0B;IAC9B;;IAEA,sCAAsC;IACtC;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,6BAA6B;QAC7B,uBAAuB;QACvB,6BAA6B;QAC7B,0BAA0B;QAC1B,2BAA2B;QAC3B,yBAAyB;IAC7B;;AAEJ","sourcesContent":[".simple_earn_wrapper {\n    padding: 40px 0 80px;\n    background-color: transparent;\n    min-height: 80vh;\n}\n\n/* button.aboutbtn_launchpad.earnbtn_simple {\n    background-color: #f5f6f7;\n    color: #000;\n} */\n\n.simple_earn_wrapper .container {\n    max-width: 1240px;\n}\n\n/* Header and Banner section styling */\n.launchpad_cnt_block {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 18px;\n}\n\n.launchpad_left_cnt {\n    flex: 1;\n}\n\n.launchpad_right_cnt {\n    max-width: 440px;\n}\n\nbody.light_theme .about-modal-intro-text {\n    color: #353535 !important;\n}\n\n.launchpad_right_cnt img {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n.launchpad_cnt_block h1 {\n    color: #ffffff;\n    font-weight: 700;\n}\n\nbody.light_theme .launchpad_cnt_block h1 {\n    color: #070808;\n}\n\n.launchpad_cnt_block p {\n    color: #84888C;\n    font-size: 20px;\n    font-weight: 500;\n    margin: 18px 0px;\n}\n\n.launchpad_cnt_block ul {\n    list-style: none;\n    padding: 0;\n    margin: 40px 0px 15px;\n    display: flex;\n    align-items: center;\n    gap: 18px;\n}\n\n.launchpad_cnt_block ul li {\n    display: flex;\n    flex-direction: column;\n    color: #ffffff;\n    font-size: 29px;\n    line-height: 26px;\n    font-weight: 600;\n}\n\nbody.light_theme .launchpad_cnt_block ul li {\n    color: #070808;\n}\n\n.launchpad_cnt_block ul li span {\n    color: #84888C;\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.about_Launchpad_btn button {\n    min-height: 56px;\n    border-radius: 50px;\n    border: none;\n    background-color: #F5F6F7;\n    transition: all 0.2s;\n}\n\n.about_Launchpad_btn button:hover {\n    filter: brightness(0.9);\n}\n\n.about_Launchpad_btn button.aboutbtn_launchpad {\n    background-color: #303236;\n    color: #fff;\n    font-size: 17px;\n    font-weight: 500;\n    padding: 10px 30px;\n}\n\nbody.light_theme .about_Launchpad_btn button.aboutbtn_launchpad {\n    background-color: #1e2329;\n}\n\n.about_Launchpad_btn button.notification_btn {\n    width: 56px;\n    background-color: #303236;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\nbody.light_theme .about_Launchpad_btn button.notification_btn {\n    background-color: #F5F6F7;\n    color: #000000;\n}\n\n.about_Launchpad_btn button i {\n    font-size: 20px;\n}\n\n.recommed_btn .more_btn {\n    border: none;\n    padding: 0px;\n    font-size: 16px;\n    background: none;\n    color: #fff;\n}\n\nbody.light_theme .recommed_btn .more_btn {\n    color: #292929;\n}\n\n/* Market Section General */\n.market-section {\n    padding: 40px 0;\n    margin-top: 40px;\n}\n\n.market-title {\n    font-size: 28px;\n    font-weight: 700;\n    color: #ffffff;\n}\n\nbody.light_theme .market-title {\n    color: #070808;\n}\n\n/* Controls */\n.market-controls {\n    display: flex;\n    gap: 15px;\n    align-items: center;\n}\n\n/* Custom Dropdown styling */\n.market-dropdown-wrapper {\n    position: relative;\n    width: 180px;\n    z-index: 100;\n}\n\n.market-dropdown-btn {\n    width: 100%;\n    background-color: #1e2329;\n    color: #eaeaea;\n    border: 1px solid #2d3139;\n    border-radius: 8px;\n    padding: 10px 16px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    transition: border-color 0.2s, background-color 0.2s;\n}\n\n.market-dropdown-btn:hover {\n    border-color: #f0b90b;\n}\n\nbody.light_theme .market-dropdown-btn {\n    background-color: #f5f6f7;\n    color: #1a1a1a;\n    border-color: #eaeaea;\n}\n\n\n.dropdown-chev {\n    transition: transform 0.2s;\n}\n\n.dropdown-chev.open {\n    transform: rotate(180deg);\n}\n\n.market-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 5px);\n    left: 0;\n    width: 100%;\n    background-color: #1e2329;\n    border: 1px solid #2d3139;\n    border-radius: 8px;\n    padding: 8px 0;\n    margin: 0;\n    list-style: none;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);\n    max-height: 250px;\n    overflow-y: auto;\n}\n\nbody.light_theme .market-dropdown-menu {\n    background-color: #ffffff;\n    border-color: #eaeaea;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n}\n\n.market-dropdown-item {\n    padding: 10px 16px;\n    font-size: 14px;\n    color: #eaeaea;\n    cursor: pointer;\n    transition: background-color 0.2s, color 0.2s;\n}\n\n.market-dropdown-item:hover {\n    background-color: #2b3139;\n}\n\n.market-dropdown-item.active {\n    background-color: #2b3139;\n    font-weight: 500;\n}\n\nbody.light_theme .market-dropdown-item {\n    color: #1a1a1a;\n}\n\nbody.light_theme .market-dropdown-item:hover,\nbody.light_theme .market-dropdown-item.active {\n    background-color: #f5f6f7;\n}\n\n/* Search input */\n.market-search-wrapper {\n    position: relative;\n    width: 240px;\n}\n\n.market-search-wrapper .search-icon {\n    position: absolute;\n    left: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #848e9c;\n    font-size: 16px;\n}\n\n.market-search-input {\n    width: 100%;\n    background-color: #1e2329;\n    color: #ffffff;\n    border: 1px solid #2d3139;\n    border-radius: 8px;\n    padding: 10px 16px 10px 40px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s;\n}\n\n.market-search-input:focus {\n    border-color: #f0b90b;\n}\n\nbody.light_theme .market-search-input {\n    background-color: #f5f6f7;\n    color: #1a1a1a;\n    border-color: #eaeaea;\n}\n\n/* Table Container & Table */\n.market-table-container {\n    width: 100%;\n    overflow-x: auto;\n    background-color: #12161a;\n}\n\nbody.light_theme .market-table-container {\n    background-color: #ffffff;\n}\n\n.market-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.market-table th {\n    padding: 18px 15px;\n    color: #848e9c;\n    font-size: 14px;\n    font-weight: 500;\n}\n\nbody.light_theme .market-table th {\n    color: #707a8a;\n}\n\n.market-table td {\n    padding: 20px 15px;\n    font-size: 15px;\n    vertical-align: middle;\n    color: #e2e2e2;\n    font-weight: 500;\n\n}\n\nbody.light_theme .market-table td {\n    color: #121212;\n}\n\n/* Main Rows */\n.market-main-row {\n    transition: background-color 0.2s;\n}\n\n.market-main-row:hover {\n    background-color: #1a1f26;\n}\n\n.market-main-row.expanded {\n    background-color: #1a1f26;\n    border-bottom: none;\n}\n\n\nbody.light_theme .market-main-row:hover {\n    background-color: #fafafa;\n}\n\nbody.light_theme .market-main-row.expanded {\n    background-color: #fafafa;\n    border-bottom: none;\n}\n\n/* Coin Cell */\n.market-coin-icon {\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n}\n\n.market-coin-name {\n    font-size: 16px;\n    font-weight: 600;\n    color: #ffffff;\n}\n\nbody.light_theme .market-coin-name {\n    color: #1a1a1a;\n}\n\n.market-coin-fullname {\n    font-size: 13px;\n    color: #848e9c;\n    display: block;\n    margin-top: 2px;\n}\n\n/* Badges / Tags */\n.market-tag {\n    font-size: 10px;\n    font-weight: 600;\n    padding: 2px 6px;\n    border-radius: 4px;\n    text-transform: uppercase;\n}\n\n.tag-vip {\n    background-color: rgba(240, 185, 11, 0.15);\n    color: #f0b90b;\n}\n\n.tag-event {\n    background-color: rgba(58, 142, 230, 0.15);\n    color: #3a8ee6;\n}\n\n.tag-bonus {\n    background-color: rgba(234, 179, 8, 0.15);\n    color: #eab308;\n}\n\n/* APR text */\n.green_text {\n    color: #03a66d !important;\n    font-weight: 600;\n}\n\n.market-term-summary {\n    color: #eaeaea;\n    font-weight: 500;\n}\n\nbody.light_theme .market-term-summary {\n    color: #101010\n}\n\n.market-toggle-btn {\n    background: transparent;\n    border: none;\n    color: #848e9c;\n    cursor: pointer;\n    padding: 4px;\n    font-size: 18px;\n    transition: color 0.2s;\n}\n\n.market-toggle-btn:hover {\n    color: #ffffff;\n}\n\nbody.light_theme .market-toggle-btn:hover {\n    color: #1a1a1a;\n}\n\n.market-chev-icon {\n    display: inline-block;\n    transition: transform 0.2s;\n}\n\n.market-chev-icon.open {\n    transform: rotate(180deg);\n}\n\n/* Sub-row Styling (Expanded Campaigns) */\n.market-sub-row {\n    background-color: #161a1f;\n}\n\nbody.light_theme .market-sub-row {\n    background-color: #ffffff;\n}\n\n.market-sub-empty-cell {\n    width: 25%;\n}\n\n/* APR Value with Tag and Trend */\n.market-sub-apr-value.underlined {\n    font-size: 15px;\n    font-weight: 500;\n    color: #ffffff;\n    cursor: pointer;\n}\n\nbody.light_theme .market-sub-apr-value.underlined {\n    color: #1a1a1a;\n}\n\n/* Sub Badges */\n.market-sub-badge {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 4px;\n    display: inline-block;\n}\n\n.badge-bonus {\n    background-color: rgba(3, 166, 109, 0.12);\n    color: #03a66d;\n}\n\nbody.light_theme .badge-bonus {\n    background-color: #e6fdf4;\n    color: #03a66d;\n}\n\n.badge-v5-14 {\n    background-color: rgba(240, 185, 11, 0.15);\n    color: #d1aa67;\n}\n\nbody.light_theme .badge-v5-14 {\n    background-color: #fff9e6;\n    color: #d1aa67;\n}\n\n.badge-new-users-exclusive {\n    background-color: rgba(0, 184, 217, 0.15);\n    color: #00b8d9;\n}\n\nbody.light_theme .badge-new-users-exclusive {\n    background-color: #e6fbfd;\n    color: #008da6;\n}\n\n.badge-crazy-wednesday {\n    background-color: rgba(0, 184, 217, 0.15);\n    color: #00b8d9;\n}\n\nbody.light_theme .badge-crazy-wednesday {\n    background-color: #e6fbfd;\n    color: #008da6;\n}\n\n.sub-row-chart-icon {\n    font-size: 14px;\n    color: #848e9c;\n}\n\n/* Term Pills */\n.sub-term-pill {\n    background-color: #1e2329;\n    color: #848e9c;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    padding: 6px 14px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.sub-term-pill:hover {\n    border-color: rgba(255, 255, 255, 0.3);\n}\n\n.sub-term-pill.active {\n    border-color: #ffffff;\n    background-color: transparent;\n    color: #ffffff;\n    font-weight: 600;\n}\n\nbody.light_theme .sub-term-pill {\n    background-color: #f5f6f7;\n    color: #5e6673;\n}\n\nbody.light_theme .sub-term-pill:hover {\n    border-color: rgba(0, 0, 0, 0.2);\n}\n\nbody.light_theme .sub-term-pill.active {\n    border-color: #1e2329;\n    background-color: #ffffff;\n    color: #1e2329;\n    font-weight: 600;\n}\n\n/* Subscribe button */\n.market-subscribe-btn {\n    background-color: #2b3139;\n    color: #ffffff;\n    border: none;\n    border-radius: 20px;\n    padding: 8px 24px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s, transform 0.1s;\n}\n\n.market-subscribe-btn:hover {\n    background-color: #1e2329;\n}\n\n.market-subscribe-btn:active {\n    transform: scale(0.97);\n}\n\nbody.light_theme .market-subscribe-btn {\n    background-color: #2b3139;\n    color: #ffffff;\n}\n\nbody.light_theme .market-subscribe-btn:hover {\n    background-color: #000000;\n}\n\n/* Pagination Row */\n.market-pagination {\n    font-size: 13px;\n    color: #848e9c;\n}\n\n.pagination-controls {\n    display: flex;\n    gap: 4px;\n}\n\n.pagination-btn {\n    background-color: #1e2329;\n    color: #eaeaea;\n    border: 1px solid #2d3139;\n    border-radius: 6px;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.pagination-btn:hover:not(.disabled):not(.active) {\n    border-color: #f0b90b;\n    color: #f0b90b;\n}\n\n.pagination-btn.active {\n    background-color: #D1AA67;\n    color: #000000;\n    border-color: #D1AA67;\n    font-weight: 600;\n}\n\n.pagination-btn.disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\nbody.light_theme .pagination-btn {\n    background-color: #ffffff;\n    color: #4b4f56;\n    border-color: #eaeaea;\n}\n\nbody.light_theme .pagination-btn:hover:not(.disabled):not(.active) {\n    border-color: #D1AA67;\n    color: #D1AA67;\n}\n\nbody.light_theme .pagination-btn.active {\n    background-color: #D1AA67;\n    color: #ffffff;\n    border-color: #D1AA67;\n}\n\n/* About Simple Earn Modal styling */\n.about-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: #000000ba;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 99999999;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    animation: fadeInModal 0.25s ease-out;\n}\n\nbody.light_theme .about-modal-overlay {\n    background-color: rgb(255 255 255 / 20%);\n}\n\n.about-modal-content {\n    background-color: #1a1a1a69;\n    color: #e1e1e1 !important;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    width: 90%;\n    max-width: 600px;\n    max-height: 85vh;\n    border-radius: 20px;\n    padding: 32px;\n    position: relative;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n    display: flex;\n    flex-direction: column;\n    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    box-sizing: border-box;\n}\n\nbody.light_theme .about-modal-content {\n    background-color: #ffffff !important;\n    color: #1e2329 !important;\n}\n\n.about-modal-close {\n    position: absolute;\n    top: 24px;\n    right: 24px;\n    background: transparent;\n    border: none;\n    font-size: 24px;\n    color: #848e9c !important;\n    cursor: pointer;\n    transition: color 0.2s, transform 0.2s;\n    padding: 4px;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.about-modal-close:hover {\n    color: #d3d3d3 !important;\n}\n\nbody.light_theme .about-modal-title {\n    color: #1e2329 !important;\n}\n\n.about-modal-title {\n    font-size: 22px;\n    font-weight: 700;\n    color: #dddddd !important;\n    margin: 0 0 24px 0;\n    line-height: 1.2;\n}\n\nbody.light_theme .about-modal-title {\n    color: #1e2329 !important;\n}\n\n.about-modal-tabs {\n    display: flex;\n    gap: 24px;\n    border-bottom: 1px solid #eaeaea;\n    margin-bottom: 20px;\n}\n\n.about-modal-tab {\n    background: transparent;\n    border: none;\n    font-size: 16px;\n    font-weight: 600;\n    color: #848e9c !important;\n    padding: 0 0 12px 0;\n    cursor: pointer;\n    position: relative;\n    transition: color 0.2s;\n}\n\n.about-modal-tab:hover {\n    color: #dfdfdf !important;\n}\n\nbody.light_theme .about-modal-tab:hover {\n    color: #1e2329 !important;\n}\n\n.about-modal-tab.active {\n    color: #dfdfdf !important;\n}\n\nbody.light_theme .about-modal-tab.active {\n\n    color: #1e2329 !important;\n}\n\n.about-modal-tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background-color: #eaeaea;\n    border-radius: 2px;\n}\n\nbody.light_theme .about-modal-tab.active::after {\n    background-color: #1e2329;\n}\n\n.about-modal-body {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n.about-modal-subtabs {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 20px;\n}\n\n.about-modal-subtab {\n    background: transparent;\n    border: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: #848e9c !important;\n    padding: 8px 16px;\n    border-radius: 20px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.about-modal-subtab:hover {\n    color: #dddddd !important;\n}\n\nbody.light_theme .about-modal-subtab:hover {\n    color: #1e2329 !important;\n}\n\n.about-modal-subtab.active {\n    background-color: #f5f6f7 !important;\n    color: #1e2329 !important;\n}\n\n.about-modal-scrollable {\n    overflow-y: auto;\n    padding-right: 8px;\n    flex: 1;\n    max-height: 42vh;\n}\n\n.about-modal-scrollable::-webkit-scrollbar {\n    width: 6px;\n}\n\n.about-modal-scrollable::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.about-modal-scrollable::-webkit-scrollbar-thumb {\n    background: #e2e8f0;\n    border-radius: 3px;\n}\n\n.about-modal-scrollable::-webkit-scrollbar-thumb:hover {\n    background: #cbd5e1;\n}\n\n.about-modal-intro-text {\n    font-size: 15px;\n    font-weight: 600;\n    color: #e0e0e0 !important;\n    line-height: 1.5;\n    margin-bottom: 24px;\n}\n\nbody.light_theme .about-modal-section p {\n    color: #1e2329 !important;\n}\n\n.about-modal-section {\n    margin-bottom: 24px;\n}\n\n.about-modal-section h4 {\n    font-size: 16px;\n    font-weight: 700;\n    color: #ffffff !important;\n    margin: 0 0 8px 0;\n}\n\nbody.light_theme .about-modal-section h4 {\n    color: #1e2329 !important;\n}\n\n.about-modal-section p {\n    font-size: 14px;\n    color: #d5d5d5 !important;\n    line-height: 1.6;\n    margin: 0 0 12px 0;\n}\n\nbody.light_theme .about-modal-section p {\n    color: #4b5563 !important;\n}\n\n.about-modal-section p:last-child {\n    margin-bottom: 0;\n}\n\n.about-modal-learn-more {\n    font-size: 14px;\n    font-weight: 700;\n    color: #1e2329 !important;\n    text-decoration: underline;\n    display: inline-block;\n    margin-top: 8px;\n    margin-bottom: 16px;\n    transition: opacity 0.2s;\n}\n\n.about-modal-learn-more:hover {\n    opacity: 0.8;\n}\n\n.about-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 24px;\n}\n\n.about-modal-guide-btn {\n    background-color: #1e2329 !important;\n    color: #ffffff !important;\n    border: none;\n    border-radius: 24px;\n    padding: 10px 24px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s, transform 0.1s;\n}\n\n.about-modal-guide-btn:hover {\n    background-color: #000000 !important;\n}\n\n.about-modal-guide-btn:active {\n    transform: scale(0.97);\n}\n\n@keyframes fadeInModal {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes slideUpModal {\n    from {\n        transform: translateY(20px);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@media screen and (max-width:1200px) {\n\n    .launchpad_right_cnt {\n        max-width: 330px;\n    }\n\n\n}\n\n\n@media screen and (max-width:991px) {\n    .launchpad_right_cnt {\n        max-width: 280px;\n    }\n\n}\n\n@media screen and (max-width:767px) {\n\n    .launchpad_cnt_block {\n        flex-direction: column-reverse;\n        text-align: center;\n        gap: 24px;\n    }\n\n    .launchpad_right_cnt {\n        max-width: 230px;\n        margin-top: 0px;\n        order: -1;\n    }\n\n    .launchpad_cnt_block p {\n        font-size: 16px;\n        margin: 12px 0px;\n    }\n\n    .launchpad_cnt_block ul {\n        margin: 20px 0px 15px;\n        justify-content: center;\n        flex-wrap: wrap;\n        gap: 16px;\n    }\n\n    .launchpad_cnt_block ul li {\n        font-size: 19px;\n        line-height: 20px;\n    }\n\n    .about_Launchpad_btn {\n        justify-content: center;\n    }\n\n    .about_Launchpad_btn button.aboutbtn_launchpad {\n        font-size: 14px;\n        padding: 6px 20px;\n    }\n\n    .about_Launchpad_btn button.notification_btn {\n        width: 42px;\n        padding: 0px;\n    }\n\n    .about_Launchpad_btn button {\n        min-height: 42px;\n    }\n\n    .about-modal-overlay {\n        align-items: end;\n    }\n\n    .about-modal-content {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 16px 16px 0px 0px;\n        padding: 24px;\n        box-shadow: 0 20px 40px rgb(0 0 0 / 73%);\n    }\n\n    .about-modal-title {\n        font-size: 18px;\n    }\n\n    .about-modal-tab {\n        font-size: 14px;\n    }\n\n    .about-modal-section p {\n        font-size: 13px;\n    }\n\n    .about-modal-guide-btn {\n        padding: 8px 24px;\n        font-size: 13px;\n    }\n\n\n\n}\n\n/* Subscription Modal styling */\n.sub-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: #000000ba;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 99999999;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    animation: fadeInModal 0.25s ease-out;\n}\n\nbody.light_theme .sub-modal-overlay {\n    background-color: rgb(255 255 255 / 20%);\n}\n\n.sub-modal-content {\n    background-color: #1a1a1a69;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    color: #e0e0e0 !important;\n    width: 95%;\n    max-width: 820px;\n    max-height: 90vh;\n    border-radius: 20px;\n    padding: 32px;\n    position: relative;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n    display: flex;\n    flex-direction: column;\n    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    box-sizing: border-box;\n}\n\nbody.light_theme .sub-modal-content {\n    background-color: #ffffff !important;\n    color: #1e2329 !important;\n}\n\n.sub-modal-close {\n    position: absolute;\n    top: 24px;\n    right: 24px;\n    background: transparent;\n    border: none;\n    font-size: 24px;\n    color: #848e9c !important;\n    cursor: pointer;\n    transition: color 0.2s, transform 0.2s;\n    padding: 4px;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n}\n\n.sub-modal-close:hover {\n    color: #1e2329 !important;\n}\n\n.sub-modal-layout {\n    display: flex;\n    gap: 40px;\n    margin-top: 10px;\n}\n\n/* Left Column Styling */\n.sub-modal-left {\n    flex: 1.1;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.sub-modal-coin-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n.sub-modal-coin-icon {\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n}\n\n.sub-modal-coin-name {\n    font-size: 22px;\n    font-weight: 700;\n    color: #e6e6e6;\n}\n\nbody.light_theme .sub-modal-coin-name {\n\n    color: #1e2329;\n}\n\n/* Term selector cards */\n.sub-modal-term-list {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 24px;\n    overflow-x: auto;\n    padding-bottom: 6px;\n}\n\n.sub-modal-term-list::-webkit-scrollbar {\n    height: 4px;\n}\n\n.sub-modal-term-list::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.sub-modal-term-list::-webkit-scrollbar-thumb {\n    background: #e2e8f0;\n    border-radius: 2px;\n}\n\n.sub-modal-term-card {\n    border: 1px solid #eaeaea1f;\n    border-radius: 12px;\n    padding: 14px 16px;\n    min-width: 105px;\n    cursor: pointer;\n    transition: all 0.2s;\n    background-color: #ffffff00;\n    box-sizing: border-box;\n}\n\nbody.light_theme .sub-modal-term-card {\n    background-color: #ffffff;\n    border: 1px solid #eaeaea;\n}\n\n.sub-modal-term-card:hover {\n    border-color: #1e2329;\n    background-color: #ffffff00;\n}\n\nbody.light_theme .sub-modal-term-card:hover {\n    border-color: #cbd5e1;\n    background-color: #fafafa;\n}\n\n.sub-modal-term-card.active {\n    border-color: #1e2329 !important;\n    border-width: 1.5px;\n}\n\n.sub-modal-term-apr {\n    font-size: 16px;\n    font-weight: 700;\n    color: #f1f1f1;\n}\n\nbody.light_theme .sub-modal-term-apr {\n    color: #1e2329;\n}\n\n.sub-modal-term-label {\n    font-size: 12px;\n    color: #848e9c !important;\n    margin-top: 4px;\n    font-weight: 500;\n}\n\n/* Amount field styling */\n.sub-modal-amount-section {\n    margin-bottom: 24px;\n}\n\n.sub-modal-amount-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.sub-modal-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: #d2d2d2 !important;\n}\n\nbody.light_theme .sub-modal-label {\n    color: #1e2329 !important;\n}\n\n.sub-modal-auto-earn {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: #d2d2d2 !important;\n    font-weight: 500;\n    cursor: pointer;\n}\n\nbody.light_theme .sub-modal-auto-earn {\n    color: #1e2329 !important;\n}\n\n.sub-modal-auto-earn input {\n    cursor: pointer;\n}\n\n.sub-modal-input-wrapper {\n    display: flex;\n    align-items: center;\n    background-color: #f5f6f705;\n    border-radius: 12px;\n    padding: 14px 16px;\n    border: 1.5px solid transparent;\n    transition: border-color 0.2s;\n}\n\nbody.light_theme .sub-modal-input-wrapper {\n    background-color: #f5f6f7;\n}\n\n.sub-modal-input-wrapper:focus-within {\n    border-color: #1e2329;\n    background-color: #ffffff;\n}\n\n.sub-modal-amount-input {\n    border: none;\n    background: transparent;\n    font-size: 16px;\n    font-weight: 600;\n    color: #1e2329 !important;\n    width: 60%;\n    outline: none;\n    padding: 0;\n}\n\n.sub-modal-input-right {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-left: auto;\n}\n\n.sub-modal-token-name {\n    font-weight: 700;\n    font-size: 14px;\n    color: #dddddd;\n}\n\nbody.light_theme .sub-modal-token-name {\n    color: #1e2329;\n}\n\n.sub-modal-input-divider {\n    width: 1px;\n    height: 16px;\n    background-color: #eaeaea;\n}\n\n.sub-modal-max-btn {\n    color: #b8860b !important;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    transition: opacity 0.2s;\n}\n\n.sub-modal-max-btn:hover {\n    opacity: 0.8;\n}\n\n.sub-modal-amount-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n    margin-top: 8px;\n}\n\n.sub-modal-available-link {\n    color: #848e9c !important;\n    border-bottom: 1px dotted #848e9c;\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\n/* .sub-modal-available-link:hover {\n    color: #1e2329 !important;\n} */\n\n.sub-modal-available-val {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    color: #d6d6d6;\n    font-weight: 600;\n}\n\nbody.light_theme .sub-modal-available-val {\n    color: #1e2329;\n}\n\n.sub-modal-add-icon {\n    color: #e5e5e5;\n    cursor: pointer;\n    font-size: 14px;\n    transition: transform 0.2s;\n}\n\nbody.light_theme .sub-modal-add-icon {\n    color: #3c3c3c;\n}\n\n.sub-modal-add-icon:hover {\n    transform: scale(1.15);\n}\n\n/* APR Box details */\n.sub-modal-apr-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #dadada;\n    margin: 0 0 12px 0;\n}\n\nbody.light_theme .sub-modal-apr-title {\n    color: #1e2329;\n}\n\n.sub-modal-apr-box {\n    border: 1px solid #f5f6f717;\n    border-radius: 12px;\n    padding: 16px;\n    background-color: #ffffff08;\n\n}\n\nbody.light_theme .sub-modal-apr-box {\n    border: 1px solid #f5f6f7;\n    background-color: #ffffff;\n}\n\n.sub-modal-apr-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 13px;\n    margin-bottom: 12px;\n}\n\n.sub-modal-apr-row:last-child {\n    margin-bottom: 0;\n}\n\n.sub-modal-apr-row-label {\n    color: #848e9c !important;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: 500;\n}\n\n.sub-modal-apr-row-val {\n    font-weight: 700;\n    color: #d8d8d8;\n}\n\nbody.light_theme .sub-modal-apr-row-val {\n    color: #1e2329;\n}\n\n.sub-modal-apr-bonus-label {\n    font-size: 11px;\n    font-weight: 700;\n    color: #848e9c !important;\n    margin-top: 14px;\n    margin-bottom: 6px;\n    text-transform: uppercase;\n}\n\n.green-tick {\n    color: #03a66d !important;\n    font-size: 15px;\n}\n\n/* Right Column Styling */\n.sub-modal-right {\n    flex: 0.9;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.sub-modal-return-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #dcdcdc !important;\n    margin: 0 0 12px 0;\n    display: inline-block;\n    border-bottom: 1px dotted #848e9c;\n    cursor: help;\n}\n\nbody.light_theme .sub-modal-return-title {\n    color: #1e2329 !important;\n}\n\n.sub-modal-return-box {\n    border: 1px solid #f5f6f717;\n    border-radius: 12px;\n    padding: 18px 16px;\n    background-color: #ffffff08;\n    margin-bottom: 24px;\n}\n\nbody.light_theme .sub-modal-return-box {\n    border: 1px solid #f5f6f7;\n    background-color: #ffffff;\n}\n\n.sub-modal-return-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 700;\n    margin-bottom: 12px;\n}\n\n.sub-modal-return-row:last-child {\n    margin-bottom: 0;\n}\n\n.sub-modal-mini-icon {\n    width: 20px;\n    height: 20px;\n    object-fit: contain;\n}\n\n.sub-modal-return-amount {\n    font-size: 15px;\n}\n\n.sub-modal-bonus-badge {\n    background-color: #e6fbfd !important;\n    color: #008da6 !important;\n    font-size: 10px;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-weight: 700;\n    margin-left: auto;\n}\n\n/* Timeline & Rules tabs */\n.sub-modal-rules-tabs {\n    display: flex;\n    gap: 20px;\n    border-bottom: 1px solid #eaeaea;\n    margin-bottom: 16px;\n}\n\n.sub-modal-rules-tab {\n    background: transparent;\n    border: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: #848e9c !important;\n    padding-bottom: 10px;\n    cursor: pointer;\n    position: relative;\n    transition: color 0.2s;\n}\n\n.sub-modal-rules-tab:hover {\n    color: #ededed !important;\n}\n\nbody.light_theme .sub-modal-rules-tab:hover {\n    color: #1e2329 !important;\n}\n\n.sub-modal-rules-tab.active {\n    color: #ededed !important;\n}\n\nbody.light_theme .sub-modal-rules-tab.active {\n    color: #1e2329 !important;\n}\n\n.sub-modal-rules-tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background-color: #1e2329;\n    border-radius: 2px;\n}\n\n.sub-modal-rules-content {\n    flex: 1;\n    min-height: 160px;\n}\n\n.sub-modal-timeline {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    position: relative;\n    padding-left: 20px;\n    padding-top: 6px;\n}\n\n.sub-modal-timeline-line {\n    position: absolute;\n    left: 5px;\n    top: 12px;\n    bottom: 12px;\n    width: 2px;\n    background-color: #eaeaea;\n}\n\n.sub-modal-timeline-step {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 13px;\n    position: relative;\n}\n\n.sub-modal-timeline-bullet {\n    position: absolute;\n    left: -20px;\n    top: 3px;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background-color: #eaeaea;\n    border: 2px solid #ffffff;\n    box-sizing: border-box;\n}\n\n.sub-modal-timeline-bullet.active {\n    background-color: #1e2329 !important;\n}\n\n.sub-modal-step-label {\n    font-weight: 600;\n    color: #e1e1e1 !important;\n    border-bottom: 1px dotted #eaeaea;\n    cursor: help;\n}\n\nbody.light_theme .sub-modal-step-label {\n    color: #1e2329 !important;\n}\n\n.sub-modal-step-val {\n    color: #848e9c !important;\n    font-weight: 500;\n}\n\n.sub-modal-product-rules {\n    font-size: 13px;\n    color: #eaeaea;\n    line-height: 1.6;\n}\n\nbody.light_theme .sub-modal-product-rules {\n    color: #4b5563;\n}\n\n.sub-modal-product-rules p {\n    margin: 0 0 10px 0;\n}\n\n.sub-modal-product-rules p:last-child {\n    margin-bottom: 0;\n}\n\n/* Footer Submit btn */\n.sub-modal-footer {\n    margin-top: auto;\n    padding-top: 16px;\n}\n\n.sub-modal-submit-btn {\n    width: 100%;\n    border: none;\n    border-radius: 24px;\n    padding: 12px;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.sub-modal-submit-btn.active {\n    background-color: #1e2329 !important;\n    color: #ffffff !important;\n}\n\n.sub-modal-submit-btn.active:hover {\n    background-color: #000000 !important;\n}\n\n.sub-modal-submit-btn.disabled {\n    background-color: #f5f6f7 !important;\n    color: #cbd5e1 !important;\n    cursor: not-allowed;\n}\n\n/* Responsive constraints */\n@media screen and (max-width: 767px) {\n    .sub-modal-content {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 16px 16px 0 0;\n        padding: 24px;\n        max-height: 90vh;\n        overflow-y: auto;\n    }\n\n    .recommed_btn .more_btn {\n        font-size: 14px;\n    }\n\n    .sub-modal-layout {\n        flex-direction: column;\n        gap: 24px;\n        margin: 0px;\n    }\n\n    .sub-modal-rules-content {\n        min-height: auto;\n    }\n}\n\n/* Enable Auto-Earn Modal styling */\n.auto-earn-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(30, 35, 41, 0.85);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000000000;\n    backdrop-filter: blur(5px);\n    animation: fadeInModal 0.2s ease-out;\n}\n\nbody.light_theme .auto-earn-modal-overlay {\n    background-color: rgb(255 255 255 / 20%);\n}\n\n.auto-earn-modal-content {\n    background-color: #1e232999 !important;\n    color: #efefef !important;\n    width: 90%;\n    max-width: 500px;\n    border-radius: 20px;\n    border: 1px solid #2b3139;\n    padding: 32px;\n    position: relative;\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n    display: flex;\n    flex-direction: column;\n    animation: slideUpModal 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    box-sizing: border-box;\n}\n\nbody.light_theme .auto-earn-modal-content {\n    background-color: #ffffff !important;\n    color: #1e2329 !important;\n    border: none;\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\n}\n\n.auto-earn-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.auto-earn-modal-header-left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 700;\n    font-size: 18px;\n    cursor: pointer;\n    color: #eaecef !important;\n    transition: opacity 0.2s;\n}\n\nbody.light_theme .auto-earn-modal-header-left {\n    color: #1e2329 !important;\n}\n\n.auto-earn-modal-header-left:hover {\n    opacity: 0.8;\n}\n\n.auto-earn-modal-close {\n    background: transparent;\n    border: none;\n    font-size: 26px;\n    color: #848e9c !important;\n    cursor: pointer;\n    line-height: 1;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.auto-earn-modal-close:hover {\n    color: #eaecef !important;\n}\n\nbody.light_theme .auto-earn-modal-close:hover {\n    color: #1e2329 !important;\n}\n\n.auto-earn-illustration {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.auto-earn-description {\n    font-size: 14px;\n    color: #848e9c !important;\n    line-height: 1.6;\n    margin: 0 0 20px 0;\n}\n\nbody.light_theme .auto-earn-description {\n    color: #4b5563 !important;\n}\n\n.auto-earn-warning-box {\n    display: flex;\n    gap: 12px;\n    background-color: rgba(245, 158, 11, 0.1) !important;\n    border: 1px solid rgba(245, 158, 11, 0.2);\n    border-radius: 12px;\n    padding: 16px;\n    margin-bottom: 24px;\n}\n\nbody.light_theme .auto-earn-warning-box {\n    background-color: #fffbeb !important;\n    border: 1px solid #fef3c7;\n}\n\n.auto-earn-warning-icon {\n    color: #f59e0b !important;\n    font-size: 20px;\n    line-height: 1;\n}\n\n.auto-earn-warning-text {\n    font-size: 12px;\n    color: #fcd34d !important;\n    line-height: 1.5;\n    margin: 0;\n}\n\nbody.light_theme .auto-earn-warning-text {\n    color: #78350f !important;\n}\n\n.auto-earn-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n}\n\n.auto-earn-cancel-btn {\n    border: 1px solid #2b3139;\n    background-color: transparent;\n    border-radius: 24px;\n    padding: 10px 24px;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    color: #eaecef !important;\n    transition: all 0.2s;\n}\n\nbody.light_theme .auto-earn-cancel-btn {\n    border: 1px solid #eaeaea;\n    color: #1e2329 !important;\n}\n\n.auto-earn-cancel-btn:hover {\n    background-color: #2b3139 !important;\n}\n\nbody.light_theme .auto-earn-cancel-btn:hover {\n    background-color: #f5f6f7 !important;\n}\n\n.auto-earn-confirm-btn {\n    background-color: #eaecef !important;\n    color: #181a20 !important;\n    border: none;\n    border-radius: 24px;\n    padding: 10px 24px;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\nbody.light_theme .auto-earn-confirm-btn {\n    background-color: #1e2329 !important;\n    color: #ffffff !important;\n}\n\n.auto-earn-confirm-btn:hover {\n    background-color: #ffffff !important;\n}\n\nbody.light_theme .auto-earn-confirm-btn:hover {\n    background-color: #000000 !important;\n}\n\n.auto-earn-illustration {\n    filter: invert(1) hue-rotate(180deg);\n}\n\nbody.light_theme .auto-earn-illustration {\n    filter: none;\n}\n\n@media screen and (max-width: 767px) {\n    .auto-earn-modal-overlay {\n        align-items: end;\n    }\n\n    .auto-earn-modal-content {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 16px 16px 0 0;\n        padding: 24px;\n        height: 80vh;\n        overflow: scroll;\n    }\n}\n\n/* Invite Friends Modal styling */\n.invite-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: #000000ba;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 99999999;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    animation: fadeInModal 0.25s ease-out;\n}\n\nbody.light_theme .invite-modal-overlay {\n    background-color: rgb(255 255 255 / 20%) !important;\n}\n\n.invite-modal-content {\n    background-color: #1a1a1a69;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    color: #e3e3e3 !important;\n    width: 90%;\n    max-width: 680px;\n    border-radius: 20px;\n    padding: 32px;\n    position: relative;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n    display: flex;\n    flex-direction: column;\n    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    box-sizing: border-box;\n}\n\nbody.light_theme .invite-modal-content {\n    background-color: #ffffff !important;\n    color: #1e2329 !important;\n}\n\n.invite-modal-close {\n    position: absolute;\n    top: 24px;\n    right: 24px;\n    background: transparent;\n    border: none;\n    font-size: 26px;\n    color: #848e9c !important;\n    cursor: pointer;\n    transition: color 0.2s;\n    line-height: 1;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.invite-modal-close:hover {\n    color: #1e2329 !important;\n}\n\n.invite-modal-title {\n    font-size: 22px;\n    font-weight: 700;\n    color: #e1e1e1 !important;\n    margin: 0 0 24px 0;\n    line-height: 1.2;\n}\n\nbody.light_theme .invite-modal-title {\n    color: #1e2329 !important;\n}\n\n.invite-modal-layout {\n    display: flex;\n    gap: 32px;\n}\n\n/* Left side Card template */\n.invite-modal-left {\n    width: 240px;\n    flex-shrink: 0;\n    border-radius: 16px;\n    border: 1px solid #eaeaea;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.invite-card-media {\n    background-color: #12161c;\n    padding: 28px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    color: #ffffff;\n    flex: 1;\n}\n\n.invite-card-logo-container {\n    margin-bottom: 12px;\n}\n\n.invite-card-brand-name {\n    font-weight: 700;\n    font-size: 18px;\n    letter-spacing: 1px;\n    color: #ffffff !important;\n    line-height: 1.2;\n}\n\n.invite-card-tagline {\n    font-size: 11px;\n    color: #848e9c !important;\n    margin-top: 4px;\n}\n\n.invite-card-apr-badge {\n    font-size: 11px;\n    font-weight: 700;\n    color: #ffffff !important;\n    background: linear-gradient(90deg, #f39c12, #f1c40f);\n    border-radius: 12px;\n    padding: 4px 10px;\n    margin-top: 14px;\n}\n\n.invite-card-bottom {\n    padding: 16px;\n    background-color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    border-top: 1px solid #eaeaea;\n}\n\n.invite-card-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.invite-card-code-label {\n    font-weight: 700;\n    font-size: 12px;\n    color: #1e2329 !important;\n}\n\n.invite-card-reward-label {\n    font-size: 9px;\n    color: #848e9c !important;\n    line-height: 1.2;\n}\n\n.invite-card-qr {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.invite-card-qr svg {\n    width: 100% !important;\n    height: 100% !important;\n    display: block;\n}\n\n.highlight-blue {\n    color: #0066FF !important;\n    font-weight: 700;\n}\n\n/* Right side Referral setup */\n.invite-modal-right {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.invite-field-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.invite-field-label {\n    font-size: 12px;\n    font-weight: 700;\n    color: #848e9c !important;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.invite-code-input-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #f5f6f708;\n    border-radius: 10px;\n    padding: 10px 16px;\n}\n\nbody.light_theme .invite-code-input-container {\n    background-color: #f5f6f7;\n}\n\n.invite-code-text {\n    font-weight: 500;\n    font-size: 15px;\n    color: #d5d5d5 !important;\n}\n\nbody.light_theme .invite-code-text {\n    color: #1e2329 !important;\n}\n\n.invite-code-copy-btn {\n    background: #f5f6f705;\n    border: none;\n    color: #c6c6c6 !important;\n    font-size: 16px;\n    cursor: pointer;\n    padding: 4px;\n    transition: color 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\nbody.light_theme .invite-custom-textbox {\n    color: #848e9c !important;\n    background-color: #f5f6f7;\n}\n\n.invite-code-copy-btn:hover {\n    color: #1e2329 !important;\n}\n\n.invite-custom-textbox {\n    background-color: #f5f6f70a;\n    border-radius: 12px;\n    padding: 14px 16px;\n    font-size: 13px;\n    color: #dedede !important;\n    line-height: 1.6;\n    cursor: pointer;\n    transition: background-color 0.2s, border-color 0.2s;\n    border: 1.5px solid transparent;\n}\n\n/* .invite-custom-textbox:hover {\n    background-color: #eaeaea;\n    border-color: #cbd5e1;\n} */\n\n.invite-share-grid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 14px 10px;\n    margin-top: 8px;\n}\n\n.invite-share-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    cursor: pointer;\n}\n\n.invite-share-circle {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #ffffff !important;\n    font-size: 18px;\n    transition: transform 0.2s, filter 0.2s;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);\n}\n\n.invite-share-item:hover .invite-share-circle {\n    transform: translateY(-2px);\n    filter: brightness(0.95);\n}\n\n.invite-share-circle.grey-circle {\n    background-color: #f1f2f4;\n    color: #1e2329 !important;\n}\n\n.invite-share-circle.telegram-circle {\n    background-color: #229ED9;\n}\n\n.invite-share-circle.whatsapp-circle {\n    background-color: #25D366;\n}\n\n.invite-share-circle.x-circle {\n    background-color: #000000;\n}\n\n.invite-share-circle.facebook-circle {\n    background-color: #1877F2;\n}\n\n.invite-share-circle.linkedin-circle {\n    background-color: #0A66C2;\n}\n\n.invite-share-circle.line-circle {\n    background-color: #06C755;\n}\n\n.invite-share-circle.email-circle {\n    background-color: #0066FF;\n}\n\n.invite-share-name {\n    font-size: 11px;\n    color: #4b5563 !important;\n    font-weight: 600;\n    margin-top: 6px;\n}\n\n\n@media screen and (max-width: 991px) {\n\n    .about_Launchpad_btn button.aboutbtn_launchpad {\n        font-size: 14px;\n        padding: 8px 28px;\n        min-height: 40px;\n    }\n\n    .launchpad_cnt_block p {\n        font-size: 16px;\n    }\n\n    .about_Launchpad_btn button.notification_btn {\n        width: 48px;\n        min-height: 48px;\n        min-width: 48px;\n        height: 48px;\n    }\n\n}\n\n\n@media screen and (max-width: 767px) {\n    .invite-modal-content {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 16px 16px 0 0;\n        padding: 24px;\n        max-height: 90vh;\n        overflow-y: auto;\n        box-shadow: 0 20px 40px rgb(0 0 0 / 59%);\n    }\n\n    .invite-modal-layout {\n        flex-direction: column;\n        align-items: center;\n        gap: 24px;\n    }\n\n    .invite-modal-overlay {\n        align-items: end;\n    }\n\n    section.market-section.mt-5.mb-5 {\n        margin: 0px !important;\n        padding-top: 10px;\n    }\n\n    .market-title {\n        font-size: 24px;\n    }\n\n    /* Table to cardbox styling on mobile */\n    .market-table-container {\n        background: transparent !important;\n        overflow-x: visible !important;\n    }\n\n    .launchpad_cnt_block p {\n        font-size: 14px;\n    }\n\n    .market-table {\n        display: block !important;\n        width: 100% !important;\n    }\n\n    .market-table thead {\n        display: none !important;\n        /* Hide column headers on mobile */\n    }\n\n    .market-controls.d-flex.gap-3.align-items-center.flex-wrap {\n        flex-wrap: nowrap !important;\n    }\n\n    .market-search-wrapper {\n        width: auto;\n    }\n\n    .market-table tbody {\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 14px;\n        width: 100% !important;\n        padding: 4px 0;\n    }\n\n    .market-main-row {\n        display: flex !important;\n        flex-wrap: wrap !important;\n        align-items: center !important;\n        background-color: #12161a !important;\n        border-radius: 12px !important;\n        padding: 16px 20px !important;\n        margin-bottom: 0px !important;\n        border: 1px solid rgba(255, 255, 255, 0.03) !important;\n        position: relative !important;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n        transition: border-radius 0.2s ease !important;\n    }\n\n    body.light_theme .market-main-row {\n        background-color: #f8f9fa !important;\n        border: 1px solid #eaecef !important;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04) !important;\n    }\n\n    /* Adjust the border radius when main row is expanded so sub-rows merge cleanly */\n    .market-main-row.expanded {\n        border-bottom-left-radius: 0px !important;\n        border-bottom-right-radius: 0px !important;\n        background-color: #1a1f26 !important;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;\n    }\n\n    body.light_theme .market-main-row.expanded {\n        background-color: #f1f2f4 !important;\n        border-bottom: 1px solid #eaecef !important;\n    }\n\n    .market-main-row td {\n        display: block !important;\n        padding: 0px !important;\n        border: none !important;\n        background: transparent !important;\n    }\n\n    /* Column 1: Coin details */\n    .market-main-row td:nth-child(1) {\n        flex: 1 1 50% !important;\n        min-width: 0 !important;\n        display: flex !important;\n        align-items: center !important;\n    }\n\n    /* Column 2: Est. APR */\n    .market-main-row td:nth-child(2) {\n        flex: 1 1 35% !important;\n        text-align: right !important;\n        font-weight: 600 !important;\n        font-size: 16px !important;\n        padding-right: 30px !important;\n        /* Avoid overlap with absolute chev button */\n    }\n\n    /* Prepend label to APR */\n    .market-main-row td:nth-child(2)::before {\n        content: \"Est. APR\" !important;\n        font-size: 11px !important;\n        color: #848e9c !important;\n        font-weight: 400 !important;\n        display: block !important;\n        margin-bottom: 2px !important;\n    }\n\n    .market-main-row td:nth-child(2) .market-apr-value {\n        color: #03a66d !important;\n    }\n\n    /* Column 3: Term */\n    .market-main-row td:nth-child(3) {\n        flex: 1 1 100% !important;\n        /* Full width row below */\n        margin-top: 12px !important;\n        padding-top: 12px !important;\n        border-top: 1px dashed rgba(255, 255, 255, 0.06) !important;\n        display: flex !important;\n        justify-content: space-between !important;\n        align-items: center !important;\n    }\n\n    body.light_theme .market-main-row td:nth-child(3) {\n        border-top: 1px dashed #eaecef !important;\n    }\n\n    .market-main-row td:nth-child(3)::before {\n        content: \"Term\" !important;\n        font-size: 13px !important;\n        color: #848e9c !important;\n        font-weight: 500 !important;\n    }\n\n    .market-term-summary {\n        font-size: 13px !important;\n        color: #ffffff !important;\n    }\n\n    body.light_theme .market-term-summary {\n        color: #1e2329 !important;\n    }\n\n    /* Column 4: Toggle Chevron button */\n    .market-main-row td:nth-child(4) {\n        position: absolute !important;\n        right: 16px !important;\n        top: 24px !important;\n        display: block !important;\n    }\n\n    .market-toggle-btn {\n        padding: 4px !important;\n    }\n\n    /* Expanded Sub Rows (Campaigns) */\n    .market-sub-row {\n        display: flex !important;\n        flex-direction: column !important;\n        background-color: #161a20 !important;\n        border-left: 1px solid rgba(255, 255, 255, 0.04) !important;\n        border-right: 1px solid rgba(255, 255, 255, 0.04) !important;\n        padding: 16px 20px !important;\n        gap: 12px !important;\n        margin-top: 0px !important;\n    }\n\n    body.light_theme .market-sub-row {\n        background-color: #ffffff !important;\n    }\n\n    /* Last sub-row has rounded bottom corners */\n    .market-sub-row:last-of-type {\n        border-bottom-left-radius: 12px !important;\n        border-bottom-right-radius: 12px !important;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;\n        margin-bottom: 12px !important;\n    }\n\n    body.light_theme .market-sub-row:last-of-type {\n        border-bottom: 1px solid #eaecef !important;\n    }\n\n    .market-sub-row td {\n        display: block !important;\n        padding: 0px !important;\n        border: none !important;\n        background: transparent !important;\n        width: 100% !important;\n    }\n\n    .sub-modal-coin-name {\n        font-size: 20px;\n    }\n\n    .sub-modal-amount-input {\n        font-size: 13px;\n    }\n\n    .sub-modal-term-card {\n        padding: 10px 12px;\n        min-width: auto;\n    }\n\n    .sub-modal-overlay {\n        align-items: end;\n    }\n\n\n    .simple_earn_wrapper {\n        padding: 40px 0 20px;\n    }\n\n    /* Hide the empty cell td:nth-child(1) in sub-row */\n    .market-sub-row td.market-sub-empty-cell {\n        display: none !important;\n    }\n\n    /* Sub-row APR and badges */\n    .market-sub-row td:nth-child(2) {\n        display: flex !important;\n        align-items: center !important;\n        justify-content: space-between !important;\n    }\n\n    .market-sub-row td:nth-child(2)::before {\n        content: \"Campaign APR\" !important;\n        font-size: 13px !important;\n        color: #848e9c !important;\n        font-weight: 500 !important;\n    }\n\n    .market-sub-row td:nth-child(2)>div {\n        display: flex !important;\n        align-items: center !important;\n        gap: 6px !important;\n    }\n\n    /* Sub-row terms / days pills */\n    .market-sub-row td:nth-child(3) {\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 6px !important;\n        align-items: flex-start !important;\n    }\n\n    .market-sub-row td:nth-child(3)::before {\n        content: \"Select Term\" !important;\n        font-size: 13px !important;\n        color: #848e9c !important;\n        font-weight: 500 !important;\n        align-self: flex-start !important;\n    }\n\n    .sub-term-pill {\n        padding: 6px 14px !important;\n        font-size: 12px !important;\n    }\n\n    /* Sub-row Action (Subscribe Button) */\n    .market-sub-row td:nth-child(4) {\n        margin-top: 6px !important;\n        text-align: left !important;\n    }\n\n    .market-subscribe-btn {\n        width: 100% !important;\n        text-align: center !important;\n        padding: 8px !important;\n        border-radius: 8px !important;\n        font-size: 12px !important;\n        font-weight: 600 !important;\n        display: block !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
